import { render, staticRenderFns } from "./sceneSettingEdit.vue?vue&type=template&id=01541561&"
import script from "./sceneSettingEdit.vue?vue&type=script&lang=js&"
export * from "./sceneSettingEdit.vue?vue&type=script&lang=js&"
import style0 from "./sceneSettingEdit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports